// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  overflow-y: auto;
  min-height: 100vh;
}

.App-columns {
  padding-bottom: 50px; /* 하단 여백 추가 */
}

.result-container {
  scroll-margin-top: 60px;
  overflow-y: auto;
  max-height: 55vh;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  /* background: #f8fafc; */
  border-radius: 0.375rem;
  padding: 0.5rem;
  margin-top: 0.5rem;
  font-size: 0.8rem;
  flex: 1 1;
}

/* 기본 스타일 */
body {
  background-color: #f8fafc;
  color: #334155;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 앱 컨테이너 */
.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 헤더 스타일 */
.App-header {
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  color: white;
  padding: 1.5rem;
  /* text-align: center; */
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.App-header h1 {
  margin: 0;
  font-size: 1.5rem;
  color: #FFFF;
}

/* 메인 컨텐츠 영역 */
.App-columns {
  display: flex;
  flex: 1 1;
  padding: 0.5rem;
  gap: 0.5rem;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  box-sizing: border-box;
}

/* 컬럼 스타일 */
.App-column {
  flex: 1 1;
  min-width: 200px;
  max-width: 24vw;
  min-height: 70vh;
  background: white;
  border-radius: 0.5rem;
  padding: 0.75rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  overflow: visible;
  box-sizing: border-box;
}

/* .App-columns {
  display: flex;
  gap: 20px;
  padding: 20px;
  overflow-x: auto;
} */

/* .App-column {
  flex: 1;
  min-width: 300px;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
} */

.App-column:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 12px -1px rgba(0, 0, 0, 0.1);
}

/* 컬럼 헤더 */
.App-column h2 {
  color: #1e40af;
  margin: 0 0 0.3rem 0;
  font-size: 1rem;
}

.App-column h3 {
  color: #64748b;
  margin: 0 0 0.5rem 0;
  font-size: 0.9rem;
  font-weight: 500;
}

/* 컬럼 컨텐츠 */
.column-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow-y: visible;
}

/* 페르소나 섹션 */
.persona-section {
  margin-bottom: 0.5rem;
}

.persona-section h4 {
  color: #475569;
  margin: 0 0 0.3rem 0;
  font-size: 0.8rem;
}

/* 드롭다운 스타일 */
.persona-dropdown {
  width: 100%;
  padding: 0.3rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  background-color: white;
  color: #334155;
  font-size: 0.8rem;
  transition: all 0.2s ease;
}

.persona-dropdown:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* 버튼 스타일 */
button {
  /* background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%); */
  color: white;
  padding: 0.4rem 0.6rem;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  /* margin-bottom: 1rem; */
  margin: 2px;
  font-size: 0.8rem;
}

button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2);
}

button:disabled {
  background: #e2e8f0;
  cursor: not-allowed;
}

/* 결과 컨테이너 */


.result-container h4 {
  color: #1e40af;
  margin: 0 0 0.75rem 0;
  font-size: 0.9rem;
}

.result-section {
  margin-bottom: 1rem;
}

.result-section h5 {
  color: #64748b;
  margin: 0 0 0.5rem 0;
  font-size: 0.8rem;
}

.result-section p {
  margin: 0;
  color: #334155;
  font-size: 0.9rem;
  line-height: 1.5;
}

/* 이미지 갤러리 */
.image-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.image-item {
  position: relative;
  aspect-ratio: 1;
}

.image-number {
  position: absolute;
  top: 8px;
  left: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.gallery-image {
  width: 100%;
  height: auto;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.gallery-image:hover {
  transform: scale(1.05);
}

/* 에러 메시지 */
.error-message {
  background: #fee2e2;
  color: #dc2626;
  padding: 0.75rem;
  border-radius: 0.375rem;
  margin: 1rem;
  text-align: center;
  animation: shake 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}

/* 모달 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-image {
  max-width: 90%;
  max-height: 90vh;
  border-radius: 0.5rem;
}

/* 스크롤바 스타일 */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* 애니메이션 */
@keyframes shake {
  10%, 90% { transform: translateX(-1px); }
  20%, 80% { transform: translateX(2px); }
  30%, 50%, 70% { transform: translateX(-4px); }
  40%, 60% { transform: translateX(4px); }
}

.process-steps {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
  flex-shrink: 0;
}

.process-step {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  background: #f8f9fa;
  border-radius: 4px;
  opacity: 0.6;
  transition: all 0.3s ease;
  min-height: 28px;
  max-height: 28px;
}

.process-step.completed {
  opacity: 1;
  background: #e8f5e9;
}

.step-number {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #bdbdbd;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  font-size: 10px;
  font-weight: 600;
  flex-shrink: 0;
}

.process-step.completed .step-number {
  background: #4caf50;
}

.step-title {
  flex: 1 1;
  font-weight: 500;
  font-size: 11px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.step-status {
  font-size: 9px;
  color: #757575;
  min-width: 25px;
  text-align: right;
}

/* 애니메이션 효과 */
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

.animate-pulse {
  animation: pulse 1.5s infinite;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.fade-in {
  animation: fadeIn 0.5s ease-out forwards;
}

.image-grid {
  /* display: grid; */
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-top: 20px;
}

.grid-image {
  width: 90%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #eee;
}

.card-news-gallery {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;
}

.card-news-image {
  width: 100%;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.action-button {
  width: 100%;
  padding: 12px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s;
}

.action-button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.action-button:hover:not(:disabled) {
  background: #0056b3;
}

.message-number {
  font-size: 1.1rem;
  color: #0056b3;
  margin-bottom: 10px;
}

.message-content {
  padding: 10px;
}

.message-content p {
  margin: 8px 0;
  line-height: 1.5;
}

.message-content strong {
  color: #495057;
}

hr {
  border: none;
  border-top: 1px solid #dee2e6;
  margin: 15px 0;
}


.card-news-gallery {
  display: ruby;
  /* flex-direction: column; */
  gap: 20px;
  margin-top: 20px;
}

.card-item {
  position: relative;
  width: 45%;
  margin: 8px;
}

.card-news-image {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-number {
  position: absolute;
  top: 8px;
  left: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}

@keyframes progressiveText {
  0% { opacity: 1; }
  33% { opacity: 1; }
  34% { opacity: 0; }
  66% { opacity: 0; }
  67% { opacity: 1; }
  100% { opacity: 1; }
}

.processing-title {
  animation: progressiveText 2s infinite;
  display: inline-block;
  position: relative;
}

.processing-title::after {
  content: '...';
  position: absolute;
  animation: ellipsis 2s infinite;
}

@keyframes ellipsis {
  0% { content: ''; }
  25% { content: '.'; }
  50% { content: '..'; }
  75% { content: '...'; }
  100% { content: ''; }
}


.progress-container {
  margin: 1rem 0;
  padding: 0 1rem;
}

.progress-text {
  text-align: center;
  margin-top: 0.5rem;
  color: #666;
}

.error-alert {
  margin: 1rem;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  cursor: pointer;
}

.modal-content {
  max-width: 90vw;
  max-height: 90vh;
  cursor: default;
}

.progress-container {
  margin: 1rem 0;
  padding: 0 1rem;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background-color: #eee;
  border-radius: 4px;
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  background-color: #007bff;
  transition: width 0.3s ease;
}

.progress-text {
  text-align: center;
  margin-top: 0.5rem;
  color: #666;
}

.error-message {
  margin: 1rem;
  padding: 1rem;
  background-color: #fee;
  border: 1px solid #fcc;
  border-radius: 4px;
  color: #c00;
}



/* 카드뉴스 */
.card-news-container {
  padding: 5px;
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
}

.card-news-controls {
  margin-bottom: 20px;
  text-align: center;
}

.download-all-button {
  background-color: #008000;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

.download-all-button:hover {
  background-color: #006400;
}

.card-news-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 8px;
  margin-top: 10px;
}

.card-news-wrapper {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.card-news-item {
  border: 1px solid #ddd;
  border-radius: 6px;
  overflow: hidden;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.card-news-content {
  aspect-ratio: 9/16;
  padding: 8px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.card-header {
  text-align: center;
  padding: 10px 0;
}

.company-logo {
  height: 30px;
  object-fit: contain;
}

.card-image {
  flex: 1 1;
  position: relative; /* 추가 */
  width: 100%;
  display: flex; /* 추가 */
  justify-content: center; /* 추가 */
  align-items: center; /* 추가 */
  background-color: #f5f5f5; /* 추가 - 이미지 로딩 전 배경색 */
}

.generated-image {
  width: 100%;
  height: 100%;
  object-fit: contain; /* cover에서 contain으로 변경 */
  border-radius: 5%;
  display: block; /* 추가 */
}

/* 이미지 로딩 표시를 위한 새로운 스타일 */
.card-image::before {
  content: "이미지 로딩 중...";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #666;
  font-size: 14px;
  z-index: 0;
}

/* 이미지가 로드된 후에는 before 가상요소 숨김 */
.card-image img[src] {
  position: relative;
  z-index: 1;
}

.card-text {
  padding: 15px;
}

.card-title {
  font-size: 20px;
  font-weight: bold;
  color: #008000;
  margin-bottom: 10px;
  text-align: center;
}

.card-subtitle {
  /* font-size: 16px;
  color: #333;
  margin-bottom: 8px;
  text-align: center; */
}

.card-description {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.card-footer {
  text-align: center;
  padding: 10px 0;
  font-size: 12px;
  color: #888;
}

.download-button-wrapper {
  text-align: center;
}

.download-button {
  padding: 8px 20px;
  /* background-color: #f0f0f0; */
  border: 1px solid #ddd;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.download-button:hover {
  background-color: #e0e0e0;
}

.persona-textarea{
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/css/demo.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB,EAAE,aAAa;AACrC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,SAAO;AACT;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,cAAc;EACd,SAAS;EACT,8EAA8E;AAChF;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;;AAEA,cAAc;AACd;EACE,aAAa;EACb,SAAO;EACP,eAAe;EACf,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;;;;GAKG;;AAEH;;;;;;;GAOG;;AAEH;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,UAAU;AACV;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,WAAW;AACX;EACE,mEAAmE;EACnE,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,YAAY;;;AAGZ;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,+DAA+D;AACjE;;AAEA,OAAO;AACP;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,WAAW,2BAA2B,EAAE;EACxC,WAAW,0BAA0B,EAAE;EACvC,gBAAgB,2BAA2B,EAAE;EAC7C,WAAW,0BAA0B,EAAE;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,UAAU,EAAE;EAClB,MAAM,UAAU,EAAE;EAClB,MAAM,UAAU,EAAE;EAClB,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,KAAK,WAAW,EAAE;EAClB,MAAM,YAAY,EAAE;EACpB,MAAM,aAAa,EAAE;EACrB,MAAM,cAAc,EAAE;EACtB,OAAO,WAAW,EAAE;AACtB;;;AAGA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;;;AAIA,SAAS;AACT;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB,EAAE,OAAO;EAC3B,WAAW;EACX,aAAa,EAAE,OAAO;EACtB,uBAAuB,EAAE,OAAO;EAChC,mBAAmB,EAAE,OAAO;EAC5B,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAE,yBAAyB;EAC9C,iBAAiB;EACjB,cAAc,EAAE,OAAO;AACzB;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;;;uBAGqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb","sourcesContent":[".App {\n  overflow-y: auto;\n  min-height: 100vh;\n}\n\n.App-columns {\n  padding-bottom: 50px; /* 하단 여백 추가 */\n}\n\n.result-container {\n  scroll-margin-top: 60px;\n  overflow-y: auto;\n  max-height: 55vh;\n  min-height: 300px;\n  display: flex;\n  flex-direction: column;\n  /* background: #f8fafc; */\n  border-radius: 0.375rem;\n  padding: 0.5rem;\n  margin-top: 0.5rem;\n  font-size: 0.8rem;\n  flex: 1;\n}\n\n/* 기본 스타일 */\nbody {\n  background-color: #f8fafc;\n  color: #334155;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n/* 앱 컨테이너 */\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* 헤더 스타일 */\n.App-header {\n  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);\n  color: white;\n  padding: 1.5rem;\n  /* text-align: center; */\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.App-header h1 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #FFFF;\n}\n\n/* 메인 컨텐츠 영역 */\n.App-columns {\n  display: flex;\n  flex: 1;\n  padding: 0.5rem;\n  gap: 0.5rem;\n  width: 100%;\n  max-width: 100vw;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n/* 컬럼 스타일 */\n.App-column {\n  flex: 1;\n  min-width: 200px;\n  max-width: 24vw;\n  min-height: 70vh;\n  background: white;\n  border-radius: 0.5rem;\n  padding: 0.75rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  transition: all 0.3s ease;\n  overflow: visible;\n  box-sizing: border-box;\n}\n\n/* .App-columns {\n  display: flex;\n  gap: 20px;\n  padding: 20px;\n  overflow-x: auto;\n} */\n\n/* .App-column {\n  flex: 1;\n  min-width: 300px;\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n} */\n\n.App-column:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 12px -1px rgba(0, 0, 0, 0.1);\n}\n\n/* 컬럼 헤더 */\n.App-column h2 {\n  color: #1e40af;\n  margin: 0 0 0.3rem 0;\n  font-size: 1rem;\n}\n\n.App-column h3 {\n  color: #64748b;\n  margin: 0 0 0.5rem 0;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n/* 컬럼 컨텐츠 */\n.column-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow-y: visible;\n}\n\n/* 페르소나 섹션 */\n.persona-section {\n  margin-bottom: 0.5rem;\n}\n\n.persona-section h4 {\n  color: #475569;\n  margin: 0 0 0.3rem 0;\n  font-size: 0.8rem;\n}\n\n/* 드롭다운 스타일 */\n.persona-dropdown {\n  width: 100%;\n  padding: 0.3rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.375rem;\n  background-color: white;\n  color: #334155;\n  font-size: 0.8rem;\n  transition: all 0.2s ease;\n}\n\n.persona-dropdown:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* 버튼 스타일 */\nbutton {\n  /* background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%); */\n  color: white;\n  padding: 0.4rem 0.6rem;\n  border: none;\n  border-radius: 0.375rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  /* margin-bottom: 1rem; */\n  margin: 2px;\n  font-size: 0.8rem;\n}\n\nbutton:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2);\n}\n\nbutton:disabled {\n  background: #e2e8f0;\n  cursor: not-allowed;\n}\n\n/* 결과 컨테이너 */\n\n\n.result-container h4 {\n  color: #1e40af;\n  margin: 0 0 0.75rem 0;\n  font-size: 0.9rem;\n}\n\n.result-section {\n  margin-bottom: 1rem;\n}\n\n.result-section h5 {\n  color: #64748b;\n  margin: 0 0 0.5rem 0;\n  font-size: 0.8rem;\n}\n\n.result-section p {\n  margin: 0;\n  color: #334155;\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n/* 이미지 갤러리 */\n.image-gallery {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.image-item {\n  position: relative;\n  aspect-ratio: 1;\n}\n\n.image-number {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  background: rgba(0, 0, 0, 0.6);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.gallery-image {\n  width: 100%;\n  height: auto;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\n.gallery-image:hover {\n  transform: scale(1.05);\n}\n\n/* 에러 메시지 */\n.error-message {\n  background: #fee2e2;\n  color: #dc2626;\n  padding: 0.75rem;\n  border-radius: 0.375rem;\n  margin: 1rem;\n  text-align: center;\n  animation: shake 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n}\n\n/* 모달 */\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-image {\n  max-width: 90%;\n  max-height: 90vh;\n  border-radius: 0.5rem;\n}\n\n/* 스크롤바 스타일 */\n::-webkit-scrollbar {\n  width: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f5f9;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* 애니메이션 */\n@keyframes shake {\n  10%, 90% { transform: translateX(-1px); }\n  20%, 80% { transform: translateX(2px); }\n  30%, 50%, 70% { transform: translateX(-4px); }\n  40%, 60% { transform: translateX(4px); }\n}\n\n.process-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 10px;\n  flex-shrink: 0;\n}\n\n.process-step {\n  display: flex;\n  align-items: center;\n  padding: 4px 8px;\n  background: #f8f9fa;\n  border-radius: 4px;\n  opacity: 0.6;\n  transition: all 0.3s ease;\n  min-height: 28px;\n  max-height: 28px;\n}\n\n.process-step.completed {\n  opacity: 1;\n  background: #e8f5e9;\n}\n\n.step-number {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #bdbdbd;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 6px;\n  font-size: 10px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.process-step.completed .step-number {\n  background: #4caf50;\n}\n\n.step-title {\n  flex: 1;\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.step-status {\n  font-size: 9px;\n  color: #757575;\n  min-width: 25px;\n  text-align: right;\n}\n\n/* 애니메이션 효과 */\n@keyframes pulse {\n  0% { opacity: 1; }\n  50% { opacity: 0.5; }\n  100% { opacity: 1; }\n}\n\n.animate-pulse {\n  animation: pulse 1.5s infinite;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.fade-in {\n  animation: fadeIn 0.5s ease-out forwards;\n}\n\n.image-grid {\n  /* display: grid; */\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.grid-image {\n  width: 90%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 8px;\n  border: 1px solid #eee;\n}\n\n.card-news-gallery {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin-top: 20px;\n}\n\n.card-news-image {\n  width: 100%;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.action-button {\n  width: 100%;\n  padding: 12px;\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background 0.2s;\n}\n\n.action-button:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.action-button:hover:not(:disabled) {\n  background: #0056b3;\n}\n\n.message-number {\n  font-size: 1.1rem;\n  color: #0056b3;\n  margin-bottom: 10px;\n}\n\n.message-content {\n  padding: 10px;\n}\n\n.message-content p {\n  margin: 8px 0;\n  line-height: 1.5;\n}\n\n.message-content strong {\n  color: #495057;\n}\n\nhr {\n  border: none;\n  border-top: 1px solid #dee2e6;\n  margin: 15px 0;\n}\n\n\n.card-news-gallery {\n  display: ruby;\n  /* flex-direction: column; */\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.card-item {\n  position: relative;\n  width: 45%;\n  margin: 8px;\n}\n\n.card-news-image {\n  width: 100%;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.card-number {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  background: rgba(0, 0, 0, 0.6);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n@keyframes progressiveText {\n  0% { opacity: 1; }\n  33% { opacity: 1; }\n  34% { opacity: 0; }\n  66% { opacity: 0; }\n  67% { opacity: 1; }\n  100% { opacity: 1; }\n}\n\n.processing-title {\n  animation: progressiveText 2s infinite;\n  display: inline-block;\n  position: relative;\n}\n\n.processing-title::after {\n  content: '...';\n  position: absolute;\n  animation: ellipsis 2s infinite;\n}\n\n@keyframes ellipsis {\n  0% { content: ''; }\n  25% { content: '.'; }\n  50% { content: '..'; }\n  75% { content: '...'; }\n  100% { content: ''; }\n}\n\n\n.progress-container {\n  margin: 1rem 0;\n  padding: 0 1rem;\n}\n\n.progress-text {\n  text-align: center;\n  margin-top: 0.5rem;\n  color: #666;\n}\n\n.error-alert {\n  margin: 1rem;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  cursor: pointer;\n}\n\n.modal-content {\n  max-width: 90vw;\n  max-height: 90vh;\n  cursor: default;\n}\n\n.progress-container {\n  margin: 1rem 0;\n  padding: 0 1rem;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background-color: #eee;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  background-color: #007bff;\n  transition: width 0.3s ease;\n}\n\n.progress-text {\n  text-align: center;\n  margin-top: 0.5rem;\n  color: #666;\n}\n\n.error-message {\n  margin: 1rem;\n  padding: 1rem;\n  background-color: #fee;\n  border: 1px solid #fcc;\n  border-radius: 4px;\n  color: #c00;\n}\n\n\n\n/* 카드뉴스 */\n.card-news-container {\n  padding: 5px;\n  width: 100%;\n  max-height: 100%;\n  overflow-y: auto;\n}\n\n.card-news-controls {\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.download-all-button {\n  background-color: #008000;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background-color 0.3s;\n}\n\n.download-all-button:hover {\n  background-color: #006400;\n}\n\n.card-news-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.card-news-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.card-news-item {\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  overflow: hidden;\n  background: white;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.card-news-content {\n  aspect-ratio: 9/16;\n  padding: 8px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.card-header {\n  text-align: center;\n  padding: 10px 0;\n}\n\n.company-logo {\n  height: 30px;\n  object-fit: contain;\n}\n\n.card-image {\n  flex: 1;\n  position: relative; /* 추가 */\n  width: 100%;\n  display: flex; /* 추가 */\n  justify-content: center; /* 추가 */\n  align-items: center; /* 추가 */\n  background-color: #f5f5f5; /* 추가 - 이미지 로딩 전 배경색 */\n}\n\n.generated-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain; /* cover에서 contain으로 변경 */\n  border-radius: 5%;\n  display: block; /* 추가 */\n}\n\n/* 이미지 로딩 표시를 위한 새로운 스타일 */\n.card-image::before {\n  content: \"이미지 로딩 중...\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #666;\n  font-size: 14px;\n  z-index: 0;\n}\n\n/* 이미지가 로드된 후에는 before 가상요소 숨김 */\n.card-image img[src] {\n  position: relative;\n  z-index: 1;\n}\n\n.card-text {\n  padding: 15px;\n}\n\n.card-title {\n  font-size: 20px;\n  font-weight: bold;\n  color: #008000;\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.card-subtitle {\n  /* font-size: 16px;\n  color: #333;\n  margin-bottom: 8px;\n  text-align: center; */\n}\n\n.card-description {\n  font-size: 14px;\n  color: #666;\n  line-height: 1.5;\n}\n\n.card-footer {\n  text-align: center;\n  padding: 10px 0;\n  font-size: 12px;\n  color: #888;\n}\n\n.download-button-wrapper {\n  text-align: center;\n}\n\n.download-button {\n  padding: 8px 20px;\n  /* background-color: #f0f0f0; */\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.download-button:hover {\n  background-color: #e0e0e0;\n}\n\n.persona-textarea{\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
